module.exports = __webpack_public_path__ + "components/flag/static/square/se-00bb45126927de2d1d4a326cff82ece8.svg";